const sender = {
    pin1: 'lemanbleu',
    pin2: 'latele',
    pin3: 'kanal9',
    pin4: 'canalalpha',
    pin5: 'telebasel',
    pin6: 'telebielingue',
    pin7: 'telebern',
    pin8: 'telem1',
    pin9: 'telezüri',
    pin10: 'teletop',
    pin11: 'tvo',
    pin12: 'telesüdostschweiz',
    pin13: 'teleticino',
    pin14: 'tele1'
};


function resetView() {
    document.querySelectorAll('.pin').forEach(function(element) {
        element.classList.remove('testclass');
    });
    document.querySelectorAll('.text-klick').forEach(function(element) {
        element.classList.remove('d-block');
    });
    document.querySelector('.text-start').classList.add('d-none');
}

function findContent(element) {
    document.querySelector('.text-klick-'+sender[element.classList[1]]).classList.add('d-block');
}

function handleClick(event) {
    if (event.target.classList.contains('pin')) {
        resetView();
        event.target.classList.add('testclass');
        findContent(event.target);
    }
    if (event.target.classList.contains('mobile-tele-title')) {
        if (window.innerWidth >= 375) {
            if (event.target.parentNode.parentNode.offsetHeight == '60') {
                document.querySelectorAll('.mobile-row').forEach(function(element) {
                    element.style.maxHeight = '60px';
                });
                event.target.parentNode.parentNode.style.maxHeight = '850px';

            } else {
                document.querySelectorAll('.mobile-row').forEach(function(element) {
                    element.style.maxHeight = '60px';
                });
            }
        }
    }
}

document.addEventListener('click', handleClick);